
import { Options, Vue } from "vue-class-component";
import PrivilegesService from "../../service/PrivilegesService.js";
import Toaster from "../../helpers/Toaster";

interface IRoles {
    type: any;
    type_id: any;
    id: number;
    name: string;
}

@Options({
    title: "Privileges",
    components: {},
})
export default class Privileges extends Vue {
    private selectedRoleID = 0;
    private toast;
    private privilegesService;
    private home = { icon: "pi pi-home", to: "/" };
    private items = [
        { label: "Initialization", to: "initialization" },
        { label: "Privileges", to: "privileges" },
    ];

    private roles: IRoles[] = [];
    private permission: IRoles[] = [];
    private checkedPermission = [];
    private permissionTypes = [
        { id: 1, name: "Dashboard" },
        { id: 2, name: "Products" },
        { id: 3, name: "POS/Sales" },
        { id: 4, name: "Purchase" },
        { id: 5, name: "Payment Methods" },
        { id: 6, name: "Settings" },
        { id: 7, name: "Reports" },
    ];

    //DEFAULT METHOD OF TYPE SCRIPT
    created() {
        this.privilegesService = new PrivilegesService();
        this.toast = new Toaster();
    }

    //CALLNING AFTER CONSTRUCTOR GET CALLED
    mounted() {
        this.loadList();
    }

    //FETCH THE DATA FROM SERVER
    loadList() {
        this.privilegesService.getItems(this.selectedRoleID).then((data) => {
            this.roles = data.roles;
            this.permission = data.permission;
            this.checkedPermission = data.assignedPermission;
        });
    }

    savePermissions() {
        this.privilegesService
            .saveItem(this.selectedRoleID, this.checkedPermission)
            .then((res) => {
                this.toast.handleResponse(res);
            });
    }

    get groupedPermissions() {
        return this.permission.reduce((groups, item) => {
            const typeId = item.type_id; // Assuming `type_id` exists in the permission object
            item.type = this.permissionTypes.find(
                (pName) => pName.id == typeId
            )?.name; // Add the type to the item
            if (!groups[typeId]) {
                groups[typeId] = {
                    type: item.type,
                    items: [],
                };
            }
            groups[typeId].items.push(item);

            console.log(item);
            return groups;
        }, {});
    }
}
